const mutations = {
    TEAM_LOADING: (state) => {
        state.teamStatus = 'loading';
    },
    TEAM_SUCCESS: (state, data) => {
        state.teamStatus = 'success';
        Vue.set(state, 'teams', data.teams);
        Vue.set(state, 'teamsCount', data.teams_count);
    },
    TEAM_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.teamStatus = 'error';
        state.teamErrors.record(errors);
    },
    CLEAR_TEAM_ERRORS: (state) => {
        state.teamStatus = '';
        state.teamErrors.clear();
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
